import { render, staticRenderFns } from "./VMainNav.vue?vue&type=template&id=b24cfa0c&"
import script from "./VMainNav.vue?vue&type=script&lang=js&"
export * from "./VMainNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports